<div
  class="bg-elevated border-default flex max-h-full flex-col overflow-hidden rounded-md border shadow-md"
  role="group"
  [attr.aria-label]="'features.plan.warnings.finding_card' | translate">
  <div class="border-weak flex items-start gap-2 border-b px-3 py-2">
    <span class="min-w-0 flex-1">
      <span class="block text-xs font-semibold">{{ findingTitle() }}</span>
      <span class="text-text-tertiary mt-0.5 block truncate font-mono text-[10px]">
        {{ code() }}
      </span>
    </span>
    <button
      type="button"
      class="text-text-tertiary hover:text-text-primary flex h-5 w-5 shrink-0 items-center justify-center rounded transition-colors"
      [title]="'common.close' | translate"
      [attr.aria-label]="'common.close' | translate"
      (click)="dismiss.emit()">
      <i [class]="ICONS.x" class="text-xs"></i>
    </button>
  </div>

  <div class="min-h-0 flex-1 overflow-y-auto">
    <div class="px-3 py-2">
      <p class="text-xs leading-relaxed break-words">{{ body() }}</p>
    </div>

    @for (section of sections(); track section.heading) {
      <div class="border-weak border-t py-1.5">
        <p
          class="text-text-secondary px-3 pb-1 text-[10px] font-semibold tracking-wider uppercase">
          {{ section.heading }}
        </p>
        @for (entry of section.refs; track entry.ref.label) {
          @if (entry.ref.uid !== null) {
            <button
              type="button"
              data-testid="finding-card-ref"
              class="hover:bg-interactive flex w-full items-center gap-2 px-3 py-1 text-left transition-colors"
              (click)="onReferenceClick(entry.ref, $event)">
              <i
                [class]="entityIcon(entry.ref.entityType)"
                class="text-text-tertiary shrink-0 text-[11px]"></i>
              <span class="text-text-secondary shrink-0 text-[10px]">
                {{ entry.typeLabel }}
              </span>
              <span class="truncate font-mono text-[10.5px]">{{ entry.ref.uid }}</span>
              @if (entry.alsoLabel !== null) {
                <span class="text-text-tertiary shrink-0 text-[10px]">
                  {{ entry.alsoLabel }}
                </span>
              }
              <i
                [class]="ICONS.caretRight"
                class="text-text-tertiary ml-auto shrink-0 text-[10px]"></i>
            </button>
          } @else {
            <span
              data-testid="finding-card-ref"
              class="text-text-tertiary flex w-full items-center gap-2 px-3 py-1 text-[10.5px]">
              <i
                [class]="entityIcon(entry.ref.entityType)"
                class="shrink-0 text-[11px]"></i>
              <span class="truncate">{{ entry.ref.label }}</span>
            </span>
          }
        }
      </div>
    }
  </div>

  <div class="border-weak flex justify-end border-t px-3 py-1.5">
    <button
      type="button"
      class="text-text-secondary hover:text-text-primary flex items-center gap-1.5 rounded px-1.5 py-0.5 text-[10.5px] transition-colors"
      (click)="copyRequested.emit($event.shiftKey)">
      <i [class]="ICONS.copy" class="text-xs"></i>
      {{ 'features.plan.check.copy_tooltip' | translate }}
    </button>
  </div>
</div>
